import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default (overrideClasses?: any) =>
  createStyles({
    search: {
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      padding: '5px 15px',
      margin: '8px 0 16px',
      width: '100%',
    },
    searchIcon: {
      color: palette.gray,
      marginRight: 12,
      opacity: 0.5,
      fontSize: 20,
    },
    searchInput: {
      width: '100%',
      fontSize: 14,
      color: palette.darkGray,
    },
    ...overrideClasses,
  });
